import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { Page } from './Page';
import { styleLoadingScreen } from './LoadingScreen.style';

export const LoadingScreen = () => {
    const classes = styleLoadingScreen();

    return (
        <Page
            className={classes.root}
            id='static-loader'
        >
            <CircularProgress />
        </Page>
    );
}